import styled from 'styled-components';
import { StockCardStyled } from '../StockCardStyled';
import { rem } from 'polished';

export const StockCardStyledAC = styled(StockCardStyled)`
    border: none;
    border-radius: ${rem(12)};
    height: 100%;

    .delivery-date {
        span {
            font-size: ${rem('14px')};
            color: ${({ theme }) => theme.colors.grey1};
        }
        svg {
            position: relative;
            top: ${rem('1px')};
            left: ${rem('3px')};
            height: 25px;
            width: 25px;
        }
    }
`;
